import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconContentBlock24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconContentBlock24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.75 10H14V3h5a3 3 0 0 1 3 3v4zM19 4.5h-3.5v4h5V6A1.5 1.5 0 0 0 19 4.5m-8.25 7.25V6.5H6A1.5 1.5 0 0 0 4.5 8v3.75zm0 1.5H4.5V17A1.5 1.5 0 0 0 6 18.5h4.75zm1.5 0v5.25H17a1.5 1.5 0 0 0 1.5-1.5v-3.75zm7-1.5H20V17a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h6.25v6.75z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconContentBlock24);
